module.exports = __webpack_public_path__ + "public/img/Desain Logo Dan Konten Untuk Desainer Grafis.13a6f3a0.png";